import { PageLoading as AntdPageLoading } from '@ant-design/pro-components';

export default () => {
  return <AntdPageLoading />;
};
